import SsciEventPage from "./SsciEventPage";

export default SsciEventPage